
import { PackageType } from '@/types/payment';

export const calculateOriginalAmount = (packageType: PackageType): number => {
  return packageType === 'silver' ? 1499 : 2999;
};

export const calculateDiscountAmount = (
  originalAmount: number,
  discountType: string,
  discountValue: number
): number => {
  if (discountType === 'percentage') {
    return Math.round((originalAmount * discountValue) / 100);
  }
  // Fixed amount discount
  return discountValue;
};

export const calculateFinalAmount = (originalAmount: number, discountAmount: number): number => {
  const newAmount = originalAmount - discountAmount;
  // Allow 0 for 100% discount coupons (free orders)
  return Math.max(newAmount, 0);
};
